import { SlateLayout } from './layout.enum.js'

export const layoutsAdditionalContext: Record<
  SlateLayout,
  Record<string, any>
> = {
  BASIC: { mobileSidebarEnable: false },
  CLASSIC: { mobileSidebarEnable: false },
  DEFAULT: {},
  NO_HEADER: {},
}

export const DISABLED_HEADER_LAYOUT_MAPPER = {
  [SlateLayout.CLASSIC]: SlateLayout.BASIC,
  [SlateLayout.BASIC]: SlateLayout.BASIC,
  [SlateLayout.NO_HEADER]: SlateLayout.NO_HEADER,
  [SlateLayout.DEFAULT]: SlateLayout.NO_HEADER,
}

export const DISABLED_SIDEBAR_LAYOUT_MAPPER = {
  [SlateLayout.CLASSIC]: SlateLayout.CLASSIC,
  [SlateLayout.BASIC]: SlateLayout.BASIC,
  [SlateLayout.NO_HEADER]: SlateLayout.BASIC,
  [SlateLayout.DEFAULT]: SlateLayout.CLASSIC,
}

export const getLayout = (options: {
  layout: SlateLayout
  headerDisabled?: boolean
  sidebar1Disabled?: boolean
}): SlateLayout => {
  const { layout, headerDisabled, sidebar1Disabled } = options

  if (headerDisabled && sidebar1Disabled) {
    return SlateLayout.BASIC
  }

  if (headerDisabled) {
    return DISABLED_HEADER_LAYOUT_MAPPER[layout] || layout
  }

  if (sidebar1Disabled) {
    return DISABLED_SIDEBAR_LAYOUT_MAPPER[layout] || layout
  }

  return layout
}
